import { useContext } from 'react';

import { StepOne, StepTwo, StepThree, StepFour } from '../Steps';

import {
  StepOneFormProvider,
} from '../../shared/contexts';
import { QuotationInfoContext } from '../../shared/contexts/QuotationInfo';
import { StepTwoFormProvider } from '../Steps/StepTwo/contexts';
import { StepThreeFormProvider } from '../Steps/StepThree/contexts';
import { StepFourFormProvider } from '../Steps/StepFour/contexts';

import { WizardDataFormProvider } from './contexts/WizardDataForm';

import { QuotationStep } from '../../shared/interfaces';
import { LoadSavedQuotation } from '../components/LoadSavedQuotation';
import { LoadRenewalQuotation } from '../components/LoadRenewalQuotation';

export const WizardPersonalEffects = () => {
  const { currentStep, loadingSavedQuotation, loadingRenewalQuotation } = useContext(QuotationInfoContext);

  const getStepComponent = () => {
    switch (currentStep) {
      case QuotationStep.ONE:
        return <StepOne />;
      case QuotationStep.TWO:
        return <StepTwo />;
      case QuotationStep.THREE:
        return <StepThree />;
      case QuotationStep.FOUR:
        return <StepFour />;
      default:
        break;
    }
  };

  return (
    <StepOneFormProvider>
      <WizardDataFormProvider>
        <StepTwoFormProvider>
          <StepThreeFormProvider>
            <StepFourFormProvider> 
                { loadingRenewalQuotation ? <LoadRenewalQuotation /> : loadingSavedQuotation ? <LoadSavedQuotation /> : getStepComponent() }
              </StepFourFormProvider>
          </StepThreeFormProvider>
        </StepTwoFormProvider> 
      </WizardDataFormProvider>
    </StepOneFormProvider>
  );
};
